import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Calendar, User, ArrowLeft } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const BlogPost = () => {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await axios.get(`${API}/blog/${id}`);
        setPost(response.data);
      } catch (error) {
        console.error('Error fetching blog post:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchPost();
  }, [id]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-maroon text-xl">Loading...</p>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <p className="text-maroon text-xl mb-4">Blog post not found</p>
          <Link to="/blog" className="btn-primary">Back to Blog</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="py-16" data-testid="blog-post-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link to="/blog" className="inline-flex items-center space-x-2 text-maroon hover:text-terracotta mb-8">
          <ArrowLeft size={20} />
          <span className="font-semibold">Back to Blog</span>
        </Link>

        <article>
          <header className="mb-8">
            <h1 className="text-4xl sm:text-5xl font-heading font-bold text-maroon mb-4" data-testid="blog-post-title">
              {post.title}
            </h1>
            <div className="flex items-center space-x-6 text-maroon/60">
              <span className="flex items-center space-x-2">
                <User size={16} />
                <span>By {post.author}</span>
              </span>
              <span className="flex items-center space-x-2">
                <Calendar size={16} />
                <span>{new Date(post.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
              </span>
            </div>
          </header>

          <div className="mb-8">
            <img 
              src={post.image_url} 
              alt={post.title}
              className="w-full aspect-[16/9] object-cover rounded-sm border-2 border-maroon hard-shadow"
            />
          </div>

          <div className="prose prose-lg max-w-none">
            <div className="text-maroon/80 whitespace-pre-wrap leading-relaxed" data-testid="blog-post-content">
              {post.content}
            </div>
          </div>
        </article>
      </div>
    </div>
  );
};

export default BlogPost;